import React from 'react';
import DateRangePicker from '../../../components/DateRangePicker';
import { useEquipmentPage } from '../context/EquipmentPageContext';

export default function EquipmentDateRange() {
  const { range, setRange } = useEquipmentPage();
  return <DateRangePicker range={range} setRange={setRange} label="Select equipment date range"
    title="Equipment registered in this range; checks and incidents recorded in this range" />;
}
